module.exports = __webpack_public_path__ + "img/expertise.c4149b16.svg";